import React from 'react';
import { LogIn, LogOut } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';

interface Props {
  isAuthenticated: boolean;
  onSignOut: () => void;
  variant?: 'default' | 'pricing';
  className?: string;
}

export default function AuthButton({ isAuthenticated, onSignOut, variant = 'default', className = '' }: Props) {
  const navigate = useNavigate();

  const handleSignIn = async () => {
    try {
      await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/auth/callback`,
          queryParams: {
            access_type: 'offline',
            prompt: 'consent'
          }
        }
      });
    } catch (error) {
      console.error('Error signing in:', error);
    }
  };

  const handleSignOut = async () => {
    try {
      // First clear any local state
      localStorage.removeItem('supabase.auth.token');
      
      // Then sign out from Supabase
      const { error } = await supabase.auth.signOut();
      if (error) throw error;

      // Force reload the page to clear any cached state
      window.location.href = '/';
    } catch (error) {
      console.error('Error signing out:', error);
      // Fallback: force reload even if there's an error
      window.location.href = '/';
    }
  };

  const getButtonStyles = () => {
    if (variant === 'pricing') {
      return "w-full flex items-center justify-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all";
    }
    return "flex items-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors";
  };

  return isAuthenticated ? (
    <button
      onClick={handleSignOut}
      className="text-gray-600 hover:text-gray-900 font-medium"
    >
      Sign Out
    </button>
  ) : (
    <button
      onClick={handleSignIn}
      className={`${getButtonStyles()} ${className}`}
    >
      <LogIn className="w-5 h-5" />
      <span>Login With Google</span>
    </button>
  );
}